import Vue from 'vue'
import money from 'v-money'

Vue.use(money, {precision: 4})

const insertCharacterAtSpecificIdx = (value, idx, character) => {
  return value.slice(0, idx) + character + value.slice(idx)
}

export const moneyFormatter = (value) => {
  if (value) {
    let moneyFormatted = value.toString()
    let counter = 1
    for(let idx = moneyFormatted.length - 1; idx >= 0; idx--) {
      if (counter % 3 == 0) {
        moneyFormatted = insertCharacterAtSpecificIdx(moneyFormatted, idx, '.')
      }
      counter++
    }
    if (moneyFormatted[0] === '.') {
      let tmp = moneyFormatted.split('')
      tmp.splice(0, 1)
      moneyFormatted = tmp.join('')
    }
    return moneyFormatted
  }
  return value
}
